import { useMemo } from 'react'
import styled from 'styled-components'
import { match } from 'ts-pattern'

import { NumericFormat } from '@blade/std-lib'
import { Typography } from '@blade/ui-kit'
import { auditToColor } from '@root/entities/pair/ui'

import type { IconProps } from '@blade/ui-kit'
import type { PairAudit } from '@root/entities/pair'
import type { BigNumber } from 'bignumber.js'

type Props = {
  holding: BigNumber
  label: string
  icon: React.ComponentType<IconProps>
}

export const PairSnipersBundlersInsidersTooltipBodyItem = ({
  holding,
  label,
  icon,
}: Props) => {
  const Icon = icon

  const snipersPercentageFormatted = useMemo(
    () => NumericFormat.formatPreset(holding, 'percents'),
    [holding],
  )
  const color = auditToColor(holdingAuditStatus(holding))

  return (
    <Item>
      <LabelContainer>
        <Icon size={14} />
        <Label>{label}</Label>
      </LabelContainer>
      <Value style={{ color }}>{snipersPercentageFormatted}%</Value>
    </Item>
  )
}

const Item = styled.div`
  display: grid;
  align-items: center;
  grid-auto-flow: column;
  justify-content: space-between;
  gap: 8px;

  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: var(--text-11);
`

const Label = styled(Typography).attrs({ variant: 'body4-medium' })``

const LabelContainer = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  gap: 4px;
`

const Value = styled(Typography).attrs({ variant: 'body4-medium' })``

const holdingAuditStatus = (percentage: BigNumber) => {
  return match(percentage)
    .returnType<PairAudit.AuditStatus>()
    .when(
      (it) => it.gte(13),
      () => 'Danger',
    )
    .when(
      (it) => it.gte(6),
      () => 'Warning',
    )
    .otherwise(() => 'Safe')
}
